<script type="text/babel">
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],

    props: ['campaignId', 'influencerCost', 'posts'],

    data() {
        return {
            form: new SparkForm({
                influencer_cost: {
                    ...this.influencerCost,
                    amount: 0
                },
                posts: this.posts,
            }),
        }
    },

    methods: {
        applyJob() {
            Spark.post(route('api.campaign.job.store', this.campaignId), this.form).then(
                response => {
                    NavigationProvider.go(`/jobs/${response.data.id}`)
                }
            )
        },
    },
}
</script>
